export default __webpack_public_path__ + "static/experienceImg5-4fc1e32a180c2c8f064de461210342c8.webp";